import React, { Component } from "react"
import TableContratosTrash from "./TableContratosTrash"
import Layout from "../Layout"
import { Loading, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
export default class ContratosTrash extends Component {
  constructor() {
    super()
    this.getContratos = this.getContratos.bind(this)
    this.filter = this.filter.bind(this)
    this.handlePageChange = this.handlePageChange.bind(this)
    this.state = {
      contratos: [],
      initialContratos: [],
      currentPage: 1,
      showTable: false,
      pageCount: ""
    }
  }
  componentWillMount() {
    this.getContratos(1)
  }
  getContratos(page) {
    ApiHelper.getContratosTrash(page, (contratos, error) => {
      if (contratos) {
        this.setState({
          contratos: contratos.data,
          initialContratos: contratos.data,
          showTable: true,
          pageCount: contratos.last_page
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialContratos.filter(contrato => {
      return (
        contrato.objeto.toLowerCase().search(searchText) !== -1 ||
        contrato.num_contrato.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      contratos: filtered
    })
  }
  handlePageChange(data) {
    window.scrollTo(0, 0)
    this.getContratos(data.selected + 1)
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Contratos">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Contratos">
        {this.state.showTable ? (
          <TableContratosTrash
            pageCount={this.state.pageCount}
            handlePageClick={this.handlePageChange}
            filter={this.filter}
            onRestore={this.getContratos}
            sizeClass=""
            title="Contratos deletados"
            subtitle="Listagem de todos os contratos deletados"
            backgroundColor="as-blue"
            rows={this.state.contratos}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/contratos/ContratosTrash.js